<template>
  <div class="m--skin-login" style="height: 100%">
    <header>
      <div class="m-header__top t3-header"></div>
    </header>
    <div class="m-grid m-grid--hor m-grid--root m-page">
      <div
        class="m-grid__item m-grid__item--fluid m-grid m-grid--hor m-login m-login--signin m-login--2 m-login-2--skin-2"
        id="m_login">
        <div class="m-grid__item m-grid__item--fluid m-login__wrapper">
          <div class="m-login__container">
            <div class="m-login__signup" style="display: block">
              <div class="m-login__head">
                <h3 class="m-login__title">Change Password</h3>
                <div class="m-login__desc">
                  Enter details for new password
                </div>
              </div>
              <div class="m-login__form m-form">
                <form method="post" role="form" action="#" @submit.prevent="changePassword" autocomplete="off">
                  <div class="form-group m-form__group" :class="{'has-danger': errors.has('password') }">
                    <input type="password" class="form-control m-input" id="password" name="password"
                           v-validate="'required|min:8'" v-model="newPassword" placeholder="New Password" ref="password">
                    <small v-show="errors.has('password')" class="form-control-feedback">{{ errors.first('password')
                      }}
                    </small>
                  </div>
                  <div class="form-group m-form__group" :class="{'has-danger': errors.has('confirmPassword') }">
                    <input type="password" v-validate="'required|confirmed:password'" data-vv-as="password"
                           class="form-control m-input" name="confirmPassword" placeholder="Confirm Password"/>
                    <small v-show="errors.has('confirmPassword')" class="form-control-feedback">
                      {{ errors.first('confirmPassword') }}
                    </small>
                  </div>
                  <div class="m-login__form-action">
                    <button type="submit" class="btn btn-focus m-btn m-btn--pill m-btn--custom m-btn--air">
                      {{ loading }}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import api from "../../api";
  import helper from "../../helpers";
  import Welcome from "../partials/Welcome";

  export default {
    name: "ChangePassword",
    data() {
      return {
        newPassword: "",
        confirmPassword: false,
        loading: "Change Password",
        idNo: this.$store.state.idNo,
        oldPassword: this.$store.state.oldPassword
      };
    },
    components: {
      welcome: Welcome
    },
    methods: {
      changePassword() {
        this.$validator
          .validateAll()
          .then(valid => {
            if (valid) {
              let {idNo, oldPassword, newPassword} = this;
              const txType = "change-password";
              this.loading = "Loading...";
              api
                .request(txType, {idNo, oldPassword, newPassword})
                .then(response => {
                  let data = response.data;
                  if (data.status === "00") {
                    helper
                      .successAlert("Password has been changed successfully")
                      .then(() => {
                        this.$store.commit("SET_TOKEN", data.token);
                        this.$store.commit("SET_USER", data.user);

                        if (window.localStorage) {
                          window.localStorage.setItem(
                            "user",
                            JSON.stringify(data.user)
                          );
                          window.localStorage.setItem("token", data.token);
                        }
                        this.$router.push("dashboard");
                      });
                  } else {
                    this.loading = "Change Password";
                    helper.errorAlert(data.message);
                  }
                })
                .catch(error => {
                  this.loading = "Change Password";
                  helper.errorAlert(
                    "Sorry, we are unable to reset your password at this time. Please try again later."
                  );
                  console.log(error);
                });
            }
          })
          .catch(() => {
            console.log("Validation Errors");
          });
      }
    },
    beforeCreate: function () {
      if (!this.$store.state.changePassword) {
        this.$router.push("/");
      }
    }
  };
</script>



// WEBPACK FOOTER //
// src/components/auth/ChangePassword.vue